import styled from 'styled-components';
import { COLORS } from 'constants/design';
import Drawer from '@material-ui/core/Drawer';
import ListItem from '@material-ui/core/ListItem';
import { Collapse, ListItemText } from '@material-ui/core';

export const SideBarSyled = styled.div`
  .root {
    display: flex;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
  }
  .menuItemText {
    font-size: 14px;
    text-align: left;
    letter-spacing: 0.02px;
    font-weight: bold;
  }
  .MuiListItemIcon-root {
    min-width: 30px;
  }
`;

interface StyledListItemProps {
  open: boolean;
}

export const StyledListItem = styled(ListItem)<StyledListItemProps>`
  padding: 8px 16px;
  width: 100%;
  height: 36px;
  margin-left: 16px;
  margin-right: 16px;
  border-radius: 4px;
  &:hover {
    background-color: ${COLORS.BLUE_MENU_SECONDARY};
  }
  &&.Mui-selected {
    background-color: ${COLORS.BLUE_MENU_SECONDARY};
  }
  &&.MuiListItem-button {
    padding: 8px 0px 8px 8px;
    display: flex;
  }
`;

export const StyledSelectedIndicator = styled.div`
  width: 3px;
  background: ${COLORS.BLUE_MENU_SECONDARY};
  border-radius: 0px 1px 1px 0px;
`;

interface StyledDrawerProps {
  open: boolean;
}

export const StyledDrawer = styled(Drawer)<StyledDrawerProps>`
  .MuiPaper-elevation0 {
    height: 100vh;
    white-space: 'nowrap';
    width: ${props => (props.open ? '240px' : '72px')};
    transition: all 0.2s ease-in-out;
    flex-shrink: 0;
    background-color: ${COLORS.BLUE_MENU_PRIMARY};
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
  }
`;

export const Item = styled.div`
  color: ${COLORS.WHITE};
  margin-bottom: 8px;
  margin-right: 0px;
  display: flex;
  flex-wrap: nowrap;
`;

interface StyledToolbarProps {
  open: boolean;
}

export const StyledToolbar = styled.div<StyledToolbarProps>`
  height: 60px;
  margin-top: 9px;
  padding-left: 8px;
  padding-right: 8px;
  width: 100%;
  align-items: center;
  position: relative;
`;

interface StyledListItemTextProps {
  open: boolean;
}

export const StyledListItemText = styled(ListItemText)<StyledListItemTextProps>`
  opacity: ${props => (props.open ? '1' : '0')};
  transition: 'all 0.5s';
  transition-delay: '0.5s';
`;

interface StyledListItemProps {
  open: boolean;
}

export const StyledSubListItem = styled(ListItem)<StyledListItemProps>`
  padding: 8px 16px;
  padding-left: 5px;
  width: 100%;
  height: 36px;
  margin-left: 16px;
  margin-right: 16px;
  border-radius: 4px;
  &&.MuiListItem-button {
    padding: 8px 0px 8px 8px;
    display: flex;
  }
  &:hover {
    background-color: transparent;
  }
  &&.Mui-selected {
    background-color: transparent;
  }
`;

export const IconWrapper = styled.div`
  margin-right: 3px;
`;

export const StyledCollapse = styled(Collapse)`
  width: 100%;
  padding-left: 30px;
  position: relative;
`;

export const Stick = styled.div`
  position: absolute;
  width: 3px;
  height: 100%;
  background-color: rgba(0, 117, 201, 0.3);
  border-radius: 10px;
`;
